<template xml:lang="html">
  <div class>
    <div class="fr ac" style="height: 100px">
      <div style="margin-left: 242px">
        <img
            class="cursor"
            @click="go('/home/index')"
            style="width: 114px;height: 60px"
            src="/static/imgs/home/logo.png"
            alt
        />
      </div>
      <div style="margin-left: 38px;font-size: 30px">欢迎登录</div>
    </div>
    <div style="position: relative">
      <img src="/static/imgs/login/banner@2x.png" style="width: 100vw;height: 450px" alt/>

      <!--            登录-->
      <div class="login pl30 pr30 pt30">
        <el-tabs v-model="tab" :stretch="true">
          <el-tab-pane label="扫码登录" name="1">
            <div class="fc jsb ac" @click="toAuth">
              <div class="fr jc ac">
                <img
                    class="mt50"
                    src="/static/imgs/login/weixin@2x.png"
                    style="width: 77px;height: 77px"
                    alt
                />
              </div>

              <div class="mt10 fc jc ac" style="color: #666666;width: 100%">
                <div>点击微信</div>
                <div class="mt8">扫码登录</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="账号登录" name="2">
            <div>
              <div class="fr ac phone mt40">
                <img src="/static/imgs/login/phone.png" class="login-icon" alt/>
                <input v-model="submit_form.member_account" class="pl10" placeholder="手机号" type="number"/>
              </div>

              <div class="fr ac mt30">
                <div class="check-code fr ac">
                  <img class="login-icon" src="/static/imgs/login/verificationCode.png" alt/>
                  <input
                      v-model="submit_form.code"
                      placeholder="验证码"
                      style="padding-left: 10px;width: 160px"
                      type="number"
                  />
                </div>

                <div
                    v-if="!is_count_down"
                    class="check-code-btn ml10 fz12 cursor"
                    @click="getCheckCode"
                >获取验证码
                </div>
                <div v-if="is_count_down" class="check-code-btn ml10 fz16">{{ count_down }}s</div>
              </div>
              <div @click="login" class="login-btn mt30 white cursor">登录</div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <footer-bar></footer-bar>
  </div>
</template>

<script>
import FooterBar from "../../components/FooterBar";

export default {
  data() {
    return {
      tab: "1",
      is_count_down: false,
      count_down: 120,

      submit_form: {
        member_account: "",
        code: ""
      }
    };
  },
  mounted() {
  },
  methods: {
    //微信授权
    toAuth() {
      let redirect_uri = 'https://mall.beltdance.com/auth';
      let auth_url = `https://open.weixin.qq.com/connect/qrconnect?appid=wx74aceec41b124b24&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect`;
      location.href = auth_url;
    },
    //登录
    login() {
      let param = Object.assign({}, this.submit_form);

      if (param.member_account.length != 11) {
        this.$message("请输入正确的手机号");
      }
      if (!param.code) {
        this.$message("请输入验证码");
      }

      this.post("memberInterfaces/v1.0/codeLoginMember", param).then(res => {
        this.memberInfoInit(res.data);
        this.go("/home/index");
        // this.isReedProtocol(1);
      });
    },

    isReedProtocol(html_id) {
      let param = {
        html_id: html_id
      };
      this.post("settingInterfaces/v1.0/isReadHtml", param).then(res => {
        if (res.data == "1") {
          this.go("/home/index");
        } else {
          this.go("/protocol?html_id=1");
        }
      });
    },

    //    获取验证码
    getCheckCode() {
      if (this.submit_form.member_account.length != 11) {
        this.$message("请输入正确的手机号");
        return;
      }

      let param = {
        mobile: this.encrypt(this.submit_form.member_account),
        code_type: this.encrypt("login")
      };
      this.post("settingInterfaces/v1.0/sendAliCode", param).then(res => {
        //    获取验证码成功
        this.is_count_down = true;
        let i = setInterval(() => {
          this.count_down--;
          if (this.count_down == 0) {
            this.count_down = 120;
            this.is_count_down = false;
            clearInterval(i);
          }
        }, 1000);
      });
    }
  },
  components: {
    "footer-bar": FooterBar
  }
};
</script>

<style scoped lang="scss">
.login {
  position: absolute;
  right: 150px;
  top: 20px;
  width: 360px;
  height: 400px;
  background: rgb(255, 255, 255);
  box-shadow: 0 2px 9px rgba(0, 0, 0, 0.21);
  border-radius: 4px;

  .login-icon {
    width: 30px;
    height: 30px;
    margin-left: 8px;
  }

  .phone {
    width: 100%;
    height: 44px;
    border: 1px solid rgb(153, 153, 153);


  }

  .check-code {
    width: 215px;
    height: 44px;
    border: 1px solid rgb(153, 153, 153);

  }

  .check-code-btn {
    width: 99px;
    height: 44px;
    background: rgb(69, 142, 246);
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }

  .login-btn {
    width: 100%;
    height: 44px;
    text-align: center;
    line-height: 44px;
    background: rgb(69, 142, 246);
    border-radius: 4px;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/login/index.vue